import styled from 'styled-components'

export const MarqueeWrapper = styled.div`
  display: flex;
  overflow: hidden;
  gap: 2rem;
  max-width: 100%;

  @keyframes scroll-x {
    from {
      transform: translateX(0%);
    }
    to {
      transform: translateX(-100%);
    }
  }

  & .marquee-group {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    min-width: 100%;
    animation: scroll-x 15s linear infinite;
    gap: 2rem;
    @media (prefers-reduced-motion: reduce) {
      animation-play-state: paused;
    }
  }
`
